import { envSchema } from "../env.schema";

export const ENV = envSchema.parse({
  VITE_BASENAME: import.meta.env.VITE_BASENAME,
  VITE_API_BASE_PATH: import.meta.env.VITE_API_BASE_PATH,
  VITE_AUTH_ISSUER: import.meta.env.VITE_AUTH_ISSUER,
  VITE_PIP_APP_URL: import.meta.env.VITE_PIP_APP_URL,
  VITE_ENVIRONMENT_LABEL: import.meta.env.VITE_ENVIRONMENT_LABEL,
  VITE_TEST_SCENARIOS_ENABLED: import.meta.env.VITE_TEST_SCENARIOS_ENABLED,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_EDITOR: import.meta.env.VITE_SENTRY_EDITOR,
  VITE_SENTRY_ROOT_PATH: import.meta.env.VITE_SENTRY_ROOT_PATH,
  VITE_SENTRY_MODE: import.meta.env.VITE_SENTRY_MODE,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
});
